var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Box" },
    [
      _c(
        "el-form",
        [
          _c(
            "el-row",
            {
              staticStyle: { "flex-wrap": "wrap", "align-items": "center" },
              attrs: { type: "flex", justify: "start" },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c(
                    "el-form-item",
                    { staticStyle: { width: "90%" } },
                    [
                      _c(
                        "el-select",
                        {
                          on: { change: _vm.numChange },
                          model: {
                            value: _vm.numType,
                            callback: function ($$v) {
                              _vm.numType = $$v
                            },
                            expression: "numType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.waybillNumber"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.ScanNumber"),
                              value: 2,
                            },
                          }),
                        ],
                        1
                      ),
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("collectionCenter.BatchQuery"),
                          autosize: "",
                          type: "textarea",
                        },
                        on: { blur: _vm.handleNumberListChange },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.BlockNewlineNum($event)
                          },
                        },
                        model: {
                          value: _vm.numberList,
                          callback: function ($$v) {
                            _vm.numberList = $$v
                          },
                          expression: "numberList",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { staticStyle: { width: "90%" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t(
                              "collectionCenter.pleaseChoose"
                            ),
                          },
                          on: { change: _vm.changeDateType },
                          model: {
                            value: _vm.queryForm.params.dataType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "dataType", $$v)
                            },
                            expression: "queryForm.params.dataType",
                          },
                        },
                        [
                          _c("el-option", {
                            key: "1",
                            attrs: {
                              label: _vm.$t("collectionCenter.outboundTime"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            key: "2",
                            attrs: {
                              label: _vm.$t("GlobalSetObj.TimeOfOrder"),
                              value: 2,
                            },
                          }),
                        ],
                        1
                      ),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: false,
                          "default-time": ["00:00:00", "23:59:59"],
                          "end-placeholder": _vm.$t("collectionCenter.EndTime"),
                          "range-separator": _vm.$t("collectionCenter.to"),
                          "start-placeholder": _vm.$t(
                            "collectionCenter.StartTime"
                          ),
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          size: "small",
                        },
                        on: { change: _vm.dateChange },
                        model: {
                          value: _vm.timeValue,
                          callback: function ($$v) {
                            _vm.timeValue = $$v
                          },
                          expression: "timeValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "90%" },
                      attrs: { label: _vm.$t("orderImport.client") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "collectionCenter.pleaseChoose"
                            ),
                            clearable: "",
                            filterable: "",
                            size: "small",
                          },
                          model: {
                            value: _vm.queryForm.params.customerId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "customerId", $$v)
                            },
                            expression: "queryForm.params.customerId",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "shein", value: 24005 },
                          }),
                          _c("el-option", {
                            attrs: { label: "kwai", value: 24009 },
                          }),
                          _c("el-option", {
                            attrs: { label: "szanjun", value: 24020 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-search",
                        size: "mini",
                        type: "primary",
                      },
                      on: { click: _vm.searchClick },
                    },
                    [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh", size: "mini" },
                      on: { click: _vm.resetClick },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.reset")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-divider"),
      _c(
        "el-table",
        {
          staticClass: "table-class",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("CenterForSorting.ind"),
              type: "index",
              width: "60",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (_vm.queryForm.pageNumber - 1) *
                            _vm.queryForm.pageSize +
                            scope.$index +
                            1
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "waybillNumber",
              align: "center",
              label: _vm.$t("GlobalSetObj.waybillNumber"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "scanOrderNumber",
              align: "center",
              label: _vm.$t("GlobalSetObj.ScanNumber"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "customerName",
              align: "center",
              label: _vm.$t("orderImport.client"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createOrderTime",
              align: "center",
              label: _vm.$t("GlobalSetObj.TimeOfOrder"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "customerSendTime",
              align: "center",
              label: _vm.$t("collectionCenter.outboundTime"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "customerSendImg",
              align: "center",
              label: _vm.$t("collectionCenter.outboundPhotos"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.customerSendImg
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#5bc6f5",
                              cursor: "pointer",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.clickImg(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.clickSee")))]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c("el-pagination", {
            staticStyle: { margin: "10px 0" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "current-change": _vm.searchClick1,
              "size-change": _vm.searchClick,
            },
          }),
        ],
        1
      ),
      _c("el-image", {
        ref: "previewImage",
        staticStyle: { display: "none" },
        attrs: {
          src: _vm.currentImageList.img,
          "preview-src-list": _vm.currentImageList.imgArr,
          fit: "contain",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }